module.exports = __webpack_public_path__ + "img/3dzz32.6aa367a0.svg";